module.exports = __webpack_public_path__ + "sounds/question-mark-5c6317855652ea99d93a36929c3f1e27.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/question-mark.mp3
// module id = 17
// module chunks = 0